import ObjectBuilderClient from 'object-builder-ui-client';
import { CONTACT_TYPE_ID, CONVERSATION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { HUBSPOT_DEFINED } from 'customer-data-objects/associations/AssociationCategoryTypes';
import { CONVERSATIONS, CONVERSATIONS_CONTACT_ASSOCIATION_TYPE_ID } from '../_internal/constants/AppSource';
import { useMemo } from 'react';
import { useGetContactAssociationProps } from '../_internal/hooks/useGetContactAssociationProps';
import { getCrmConversationId } from 'conversations-thread-data/thread-details/public/operators';
import { useThreadDetails } from '../../thread-details-feature/public/hooks/useThreadDetails';
import { getData } from 'conversations-async-data/async-data/operators/getters';
import { jsx as _jsx } from "react/jsx-runtime";
const ContactPrompt = ({
  threadId,
  onClose
}) => {
  const {
    asyncThreadDetails
  } = useThreadDetails({
    threadId
  });
  const threadDetails = getData(asyncThreadDetails);
  const conversationId = getCrmConversationId(threadDetails) || undefined;
  const contactAssociationBuilderExtraProps = useGetContactAssociationProps({
    threadId
  });

  // if we can't get the conversation id from the thread, there is nothing to associate the new contact to
  // see https://hubspot.slack.com/archives/C01BW2K0XGE/p1733847890621469
  const defaultAssociation = useMemo(() => conversationId ? {
    objectId: `${conversationId}`,
    objectTypeId: CONVERSATION_TYPE_ID,
    associationTypeId: CONVERSATIONS_CONTACT_ASSOCIATION_TYPE_ID
  } : undefined, [conversationId]);
  return useMemo(() => /*#__PURE__*/_jsx(ObjectBuilderClient, Object.assign({
    appInfo: {
      defaultAssociation,
      associationTypeId: CONVERSATIONS_CONTACT_ASSOCIATION_TYPE_ID,
      associationCategory: HUBSPOT_DEFINED
    },
    appName: CONVERSATIONS,
    objectTypeId: CONTACT_TYPE_ID,
    onClose: onClose,
    shouldRenderCreateAndAddButton: false,
    enableFlexibleAssociations: false,
    forceSingleSelectAssociation: true,
    show: true
  }, contactAssociationBuilderExtraProps)), [onClose, contactAssociationBuilderExtraProps, defaultAssociation]);
};
ContactPrompt.displayName = 'ContactPrompt';
export default ContactPrompt;